import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import PolitiquePage from "@/pages/PolitiquePage";
import ConditionsPage from "@/pages/ConditionsPage";
import MentionsPage from "@/pages/MentionsPage";
import ProposPage from "@/pages/ProposPage";
import SupportPage from "@/pages/SupportPage";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/politique" element={<PolitiquePage />} />
          <Route path="/conditions" element={<ConditionsPage />} />
          <Route path="/mentions" element={<MentionsPage />} />
          <Route path="/propos" element={<ProposPage />} />
          <Route path="/support" element={<SupportPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
